import { APIResponse } from '../../@types';
import { makeAPICall } from './clientHelpers/makeAPICall';

export const apiClient = {
  getStatus: async (): Promise<APIResponse<null>> => {
    const { error } = await makeAPICall({
      method: 'GET',
      url: '/status',
      checkModified: false,
    });
    return {
      error,
    };
  },
};
